<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4012_1476)">
      <path
        d="M10 8.64L15.27 12L10 15.36V8.64ZM8 5V19L19 12L8 5Z"
        fill="#383838"
      />
    </g>
    <defs>
      <clipPath id="clip0_4012_1476">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
